import { useCallback } from "react"
import {
  useGraphContext,
  yAxisLabelFontSize,
} from "./GraphContext"
import { clamp } from "src/utils"


/*
 * returns a function that converts an mg_dl value to a distance from the top edge of the graph
 */
export function useGetMgdlAsTopPosition(): (
  glucoseValue: number,
) => [number, boolean] {
  const {
    topMgdl,
    bottomMgdl,
    yAxisHeight,
  } = useGraphContext()

  return useCallback(
    (mgdl: number) => {
      const range = topMgdl - bottomMgdl
      const percentage = (mgdl - bottomMgdl) / range
      const clampedPercentage = clamp(
        percentage,
        0,
        1,
      )

      /*
       * the usable height for mapping glucose values is the yAxisHeight minus
       * the yAxisLabelFontSize because the max and min glucose values should
       * aligned with the center of the max and min yAxis labels
       */
      const usableHeight = yAxisHeight - yAxisLabelFontSize
      const topPosition = (yAxisLabelFontSize / 2) + (1 - clampedPercentage) * usableHeight

      // returns position and boolean for whether or not it was clamped
      return [
        topPosition,
        percentage !== clampedPercentage,
      ]
    },
    [
      topMgdl,
      bottomMgdl,
      yAxisHeight,
    ],
  )
}
